import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

// Components
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';
import InitialLogin from './InitialLogin';

// Styles
import '../../scss/Form.scss';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Navigation handlers - simple and clean
  const handlePersonalChoice = () => {
    navigate('/login-individual', { state: location.state });
  };

  const handleSchoolChoice = () => {
    navigate('/login-school', { state: location.state });
  };

  return (
    <>
      <Helmet>
        <title>Login to Our Free Online Spelling Test Game - Spelling Hero</title>
        <meta name="description" content="Login to Spelling Hero - Choose between personal/family login or school/classroom login to access our educational spelling games and activities." />
        <meta name="keywords" content="spelling games login, educational games, school login, clever, classlink, spelling hero" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Login to Our Free Online Spelling Test Game - Spelling Hero" />
        <meta property="og:description" content="Login to Spelling Hero - Choose between personal/family login or school/classroom login to access our educational spelling games and activities." />
        <meta property="og:type" content="website" />
        
        {/* Canonical URL */}
        <link rel="canonical" href={`${window.location.origin}/login`} />
      </Helmet>

      <header>
        <Navbar currentPage="login" />
      </header>

      <main className="main-container" style={{ paddingTop: 0 }}>
        <section className="quiz-signup">
          <Box sx={{ padding: 0 }}>
            <Grid container spacing={2}>
              {/* Sidebar */}
              <Grid
                item
                lg={5}
                xs={12}
                sm={12}
                sx={{ paddingLeft: 0 }}
                className="sidebar-top-spacing"
              >
                <Sidebar />
              </Grid>

              {/* Main Content */}
              <Grid item xs={12} sm={12} lg={7} xl={7}>
                <Box sx={{
                  position: 'relative',
                  paddingLeft: { xs: 2, sm: 3, md: 4 },
                  paddingRight: { xs: 2, sm: 3, md: 4 },
                  paddingTop: 2,
                  paddingBottom: 4,
                  marginTop: { xs: 2, md: 4 }
                }}>
                  {/* Center the InitialLogin component vertically like InitialChoice */}
                  <Box sx={{ display: 'flex', alignItems: 'center', minHeight: '100%' }}>
                    <InitialLogin 
                      onPersonalClick={handlePersonalChoice}
                      onSchoolClick={handleSchoolChoice}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Login;
